import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";

import { db } from "../firebase";

import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
} from "firebase/firestore";

import {
  FaPhoneAlt,
  FaWhatsapp,
  FaMapMarkerAlt,
} from "react-icons/fa";

import "../styles/MyRides.css";

export default function MyRides() {

  const { user } = useAuth();

  const [rides, setRides] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    if (!user) return;

    const q = query(

      collection(db, "rideRequests"),

      where("customerUid", "==", user.uid),

      orderBy("createdAt", "desc")

    );

    const unsubscribe = onSnapshot(

      q,

      (snapshot) => {

        setRides(

          snapshot.docs.map(doc => ({

            id: doc.id,

            ...doc.data(),

          }))

        );

        setLoading(false);

      },

      (err) => {

        console.error(err);

        setLoading(false);

      }

    );

    return unsubscribe;

  }, [user]);

  if (loading) {

    return (

      <div className="myrides-page">

        <h3>Loading...</h3>

      </div>

    );

  }

  return (

    <div className="myrides-page">

      <h2>🚖 My Rides</h2>

      {rides.length === 0 && (

        <div className="empty-rides">

          <h3>No rides booked yet.</h3>

        </div>

      )}

      {rides.map((ride) => (

        <div
          key={ride.id}
          className="ride-card"
        >

          <div className="ride-header">

            <h3>

              {ride.driverName}

            </h3>

            <span
              className={`ride-status ${ride.status}`}
            >

              {ride.status}

            </span>

          </div>

          <p>

            🚖 {ride.autoNumber}

          </p>

          <p>

            <FaMapMarkerAlt />

            {" "}

            Pickup :

            {" "}

            {ride.pickup}

          </p>

          <p>

            <FaMapMarkerAlt />

            {" "}

            Destination :

            {" "}

            {ride.destination}

          </p>

          {ride.notes && (

            <p>

              📝 {ride.notes}

            </p>

          )}

          <div className="ride-actions">

            <a
              href={`tel:${ride.driverMobile}`}
              className="call-btn"
            >

              <FaPhoneAlt />

              Call

            </a>

            <a
              href={`https://wa.me/${ride.driverMobile}`}
              target="_blank"
              rel="noreferrer"
              className="wa-btn"
            >

              <FaWhatsapp />

              WhatsApp

            </a>

          </div>

        </div>

      ))}

    </div>

  );

}